import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { TextField, Typography, Button, Tooltip } from "@mui/material";
import "../../../Myaccount/Myaccount.css";
import Divider from "@mui/material/Divider";
import axios from "../../../../utils/fvAxios";

import { useTranslation } from "react-i18next";
import "../../../../Localization/i18n";
import apiinfo from "../../../../utils/base-uri.json";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function Security(props) {
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    NewPassword: Yup.string()
      .required("New password is required !")
      .matches(
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{10,20}$/,
        "Minimum 10 characters, maximum 20 characters, at least one upper case letter, one lower case letter, one number and one special character"
      ),
    ConfirmPassword: Yup.string()
      .required("Confirm password is required !")
      .oneOf(
        [Yup.ref("NewPassword"), null],
        "Confirm password does not match !"
      ),
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [NewPasswordErr, setNewPasswordErr] = useState("");
  const [ConfirmPasswordErr, setConfirmPasswordErr] = useState("");
  const ChangeNewPassword = (e) => {
    let reg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{10,}$/;
    if (e == "") {
      setNewPassword(e);
      setNewPasswordErr("");
    } else if (!reg.test(e)) {
      setNewPassword(e);
      setNewPasswordErr("Minimum 10 characters, at least one upper case letter, one lower case  letter, one number and one special character ");
    } else {
      setNewPassword(e);
      setNewPasswordErr("");
    }
  }
  const ChangeConfirmPassword = (e) => {
    if (e == "") {
      setConfirmPassword(e);
      setConfirmPasswordErr("");
    } else if (e != NewPassword) {
      setConfirmPassword(e);
      setConfirmPasswordErr("Confirm password does not match !");
    } else {
      setConfirmPassword(e);
      setConfirmPasswordErr("");
    }
  }

  const onSubmit = () => {
    if (NewPassword && ConfirmPassword) {
      let item = {
        newPassword: NewPassword,
        confirmPassword: ConfirmPassword,
        userId: props.userId,
      };
      setConfirmPassword("");
      setNewPassword("");
      axios.post(apiinfo.settings.ResetPassword, item).then((res) => {
        if (res?.data?.responseCode == 100) {
          toast.success(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

        } else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      });
    } else {
      toast.error("Please enter mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  return (
    <>
      <div className="form">
        <label className="personal-info-heading">
          <b>{t("Security.security")}</b>
        </label>
        {/* {error && (
          <div className="text-center" style={{ color: "red" }}>
            {error}
          </div>
        )} */}

        <div className="personal-info-subheading">
          <span>
            {t("Security.last")}:{props.date}
          </span>
        </div>

        <Divider className="mt-2" sx={{ backgroundColor: "#667085", height: "2px" }} />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">
              {t("Security.newpassword")}{" "}
              <small style={{ color: "red" }}>*</small>
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
            <Tooltip
              placement="left-start"
              title={
                <div >
                  <h6><div class='controlHintText'>Your password must meet the following requirements:<br />At least 10 characters long<br />Contain at least 1 uppercase letter<br />Contain at least 1 lowercase letter<br />Contain at least 1 number<br />Contain at least 1 special character </div></h6>
                </div>
              }
              arrow
            >
              <TextField
                autoComplete="new-password"
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                required
                type="password"
                id="NewPassword"
                name="NewPassword"
                placeholder={t("Security.newpassword")}
                size="small"
                className="form-control text-feild-custom mx-2"
                value={NewPassword}
                onChange={(e) => ChangeNewPassword(e?.target.value)}

              //{...register("NewPassword")}
              />
            </Tooltip>
            <Typography className="text-danger mt-1" component={"span"}>
              <p className="mx-2">{NewPasswordErr}</p>
            </Typography>
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
        </div>
        <Divider className="mt-3" />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">
              {t("Security.confirmpassword")}{" "}
              <small style={{ color: "red" }}>*</small>{" "}
            </span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
            <TextField
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              required
              type="password"
              id="ConfirmPassword"
              name="ConfirmPassword"
              placeholder={t("Security.confirmpassword")}
              size="small"
              className="form-control text-feild-custom mx-2"
              value={ConfirmPassword}
              onChange={(e) => ChangeConfirmPassword(e?.target.value)}
              disabled={!NewPassword || NewPasswordErr}
            //{...register("ConfirmPassword")}
            />
            <Typography className="text-danger mx-2 mt-1" component={"span"}>
              {ConfirmPasswordErr}
            </Typography>
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>

          <div className="row mt-3 mb-3">
            <div className="text-right">
              <Button
                variant="outlined"
                color="primary"
                style={{
                  marginRight: "10px",
                  textTransform: "capitalize",
                  padding: "15px",
                }}
                onClick={props.navigateToList}
              >
                {t("Myinformation.cancle")}
              </Button>
              {props?.MOD &&
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onSubmit}
                  style={{ textTransform: "capitalize", padding: "15px" }}
                  disabled={NewPasswordErr || ConfirmPasswordErr}
                >
                  {t("Myinformation.save")}
                </Button>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
